<div class="component">
    <div class="left-bar">
        <div class="entry adder" (click)="addRole()">
            <mat-icon class="icon">add</mat-icon>
            <span class="text">Rolle anlegen</span>
        </div>
        <div *ngFor="let role of roles">
            <div *ngIf="rolePointer == role.id; else unselected" class="entry selected saved" (click)="setRole(role)">
                <div *ngIf="role != null">
                    <span *ngIf="!isEmpty(role.name); else noRoleName">
                        {{ role.name }}
                    </span>
                    <ng-template #noRoleName>
                        <span class="no-value">
                            Keine Bezeichnung
                        </span>
                    </ng-template>
                </div>
            </div>
            <ng-template #unselected>
                <div class="entry saved" (click)="setRole(role)">
                    <div *ngIf="role != null">
                        <span *ngIf="!isEmpty(role.name); else noRoleName">
                            {{ role.name }}
                        </span>
                        <ng-template #noRoleName>
                            <span class="no-value">
                                Keine Bezeichnung
                            </span>
                        </ng-template>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="right-bar">
        <div *ngIf="rolePointer != null && this.currentRole != null; else noRole" class="role-edit-view">
            <div class="state-label-panel">
                <div *ngIf="currentRole.isNew; else persistedRole" class="state-label unpersisted">
                    Ungespeicherte Rolle
                </div>
                <ng-template #persistedRole>
                    <div class="state-label created">
                        Angelegt
                    </div>
                    <div class="state-label second">
                        ID {{ rolePointer }}
                    </div>
                </ng-template>
            </div>
            <mat-form-field class="form-field">
                <input
                    matInput 
                    placeholder="Rollenname"
                    [(ngModel)]="roleName"
                    (focusout)="setRoleName()"
                />
            </mat-form-field>
            <mat-form-field class="form-field">
                <mat-label>
                    Nutzer in Rolle {{ currentRole.name }}
                </mat-label>
                <mat-select
                    #roleUsers
                    multiple
                    [value]="roleUserIds"
                    (selectionChange)="setRoleUsers($event)"
                    [disabled]=true
                >
                    <mat-option *ngFor="let u of users" [value]="u.id">
                        {{ u.userName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div style="margin-bottom: 20px;">
                <div class="permit-rights-button" (click)="permitAllRights()">
                    {{ currentRole.name }} alle Rechte geben
                </div>
                <div class="permit-rights-button" (click)="permitAllNecessaryRights()">
                    {{ currentRole.name }} empfohlene Rechte geben
                </div>
            </div>
            <div *ngFor="let ruleGroup of ruleGroups">
                <div *ngIf="ruleGroup.group != null; else noGroup" class="role-group-name" (click)="toggleGroup(ruleGroup.group)">
                    <mat-icon *ngIf="isVisible(ruleGroup.group); else arrowRight" class="icon">
                        keyboard_arrow_down
                    </mat-icon>
                    <ng-template #arrowRight>
                        <mat-icon class="icon">keyboard_arrow_right</mat-icon>
                    </ng-template>
                    <span class="text">
                        {{ruleGroup.group.rulegroupname}}
                    </span>
                    <span class="counter">
                        {{ruleGroup.rules.length}}
                    </span>
                </div>
                <ng-template #noGroup>
                    <div class="role-group-name" (click)="toggleGroup(ruleGroup.group)">
                        <mat-icon *ngIf="isVisible(ruleGroup.group); else arrowRight" class="icon">
                            keyboard_arrow_down
                        </mat-icon>
                        <ng-template #arrowRight>
                            <mat-icon class="icon">keyboard_arrow_right</mat-icon>
                        </ng-template>
                        <span class="text">
                            Keine Gruppenzuordnung
                        </span>
                        <span class="counter">
                            {{ruleGroup.rules.length}}
                        </span>
                    </div>
                </ng-template>
                <div class="toggle-body" *ngIf="isVisible(ruleGroup.group)">
                    <div *ngFor="let rule of ruleGroup.rules" class="pretty-switch">
                        <mat-slide-toggle
                            (change)="setRoleRight(rule, $event)"
                            [checked]="valueMap[rule.ruleid]"
                        >
                            <div>
                                <div class="headline">
                                    {{ rule.rulename }}
                                </div>
                                <div class="subtitle">
                                    {{ rule.ruledesc }}
                                </div>
                            </div>
                        </mat-slide-toggle>
                    </div> 
                </div> 
            </div>
            <div class="rule-counter">
                Es gibt insgesamt {{ruleCount}} Regeln.
            </div>
            <div class="control-bar">
                <mat-icon
                    *ngIf="canDeleteRole()" 
                    matTooltip="Rolle löschen"
                    class="icon danger" 
                    (click)="deleteRole()"
                >delete_forever</mat-icon>
            </div>
        </div>
        <ng-template #noRole>
            <div class="centered-label">
                <mat-icon class="no-selection-icon">
                    supervised_user_circle
                </mat-icon>
                <div class="no-selection-headline">
                    Keine Rolle ausgewählt
                </div>
                <div class="no-selection-subtitle">
                    Legen Sie eine neue Rolle an oder wählen Sie eine aus um diese zu bearbeiten oder zu löschen.
                </div>
            </div>
        </ng-template>
    </div>
</div>